import {useCallback, useMemo} from 'react'
import {requestData} from 'services'
import {useDispatch} from 'lib/redux'

export function usePolicyUpdateHooks() {
  const {update} = useDispatch()

  const handleFetchPolicyStatus = useCallback(async () => {
    const response = await requestData('member_account_status')
    if (typeof response !== 'string') {
      if (response.status === 200) {
        const {
          has_mfa,
          is_consent_accepted,
          is_policy_accepted,
        } = response.data.result
        update('settingState', {
          isAuthenticatorEnabled: has_mfa,
        })
        if (is_policy_accepted) {
          update('user', {
            is_policy_accepted,
            is_consent_accepted,
          })
        }
        return {
          isPolicyAccepted: is_policy_accepted,
          hasMFA: has_mfa,
        }
      }
      return {isPolicyAccepted: true, hasMFA: true}
    }
    return {isPolicyAccepted: true, hasMFA: true}
  }, [update])

  const handleAcceptPolicyUpdate = useCallback(async () => {
    const response = await requestData('accept_privacy_policy')
    if (typeof response !== 'string') {
      return response.status
    }
    return undefined
  }, [])

  return useMemo(
    () => ({
      handleAcceptPolicyUpdate,
      handleFetchPolicyStatus,
    }),
    [handleAcceptPolicyUpdate, handleFetchPolicyStatus],
  )
}
